import { PlatformTableData } from '../api/models';

export const normalizeTableRowData = <T extends Record<string, any>>(
  tableData?: PlatformTableData,
): T[] => {
  if (tableData) {
    const { columns, rows } = tableData;

    return rows.map((rowData: any[]) => {
      const newRow: any = {};
      for (const [index, col] of columns.entries()) {
        newRow[col.name] = rowData[index];
      }

      return newRow;
    });
  }

  return [];
};
